// extracted by mini-css-extract-plugin
module.exports = {"read-more-message-hide":"ViewMore_read-more-message-hide__NQffa","read-more-button":"ViewMore_read-more-button__aJQyq","less-pdp-msg":"ViewMore_less-pdp-msg__Q_LeL"};